import React, { useContext, useState, useEffect, useRef } from 'react';
import tw from 'twin.macro';
import { getItemsList, getItemDetails } from 'services/dumpert';
import { useParams } from 'react-router-dom';
import { TimesIcon, ListAddIcon, CheckIcon } from 'icons';
import { LoadingDots } from '../../loading';
import { Input } from '../../form';
import { Title, Paragraph } from '../../text';
import { Item } from '../../item';
import { ScrollBarContent } from '../../scroll';
import { Button } from '../../button';
import { AppContext, PlaylistContext } from '../../context';

let mounted = true;

export const PlaylistAutoSuggestSearch = () => {
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef();

  const { windowSize } = useContext(AppContext);
  const { playlistItems, addItemToPlaylist } = useContext(PlaylistContext);

  const currentPlaylistId = useParams().playlistId;
  const playlistItemIds = playlistItems.map((item) => item.composite_id);

  const getSuggestions = async (isUrl, itemId) => {
    try {
      setIsLoading(true);
      const { data } = isUrl
        ? await getItemDetails({ id: itemId })
        : await getItemsList({ list: 'search', tag: inputValue, sorting: 'kudos' });
      const videoItems = data.items
        .filter((item) => item.media[0].mediatype === 'VIDEO')
        .sort((a, b) => {
          return b.stats.kudos_total - a.stats.kudos_total;
        });
      if (videoItems.length > 0) {
        setSuggestions(videoItems);
        setNoResults(false);
      } else {
        setSuggestions([]);
        setNoResults(true);
      }
    } finally {
      if (mounted) {
        setIsLoading(false);
      }
    }
  };

  const removeInput = () => {
    setInputValue('');
    setSuggestions([]);
  };

  useEffect(() => {
    const { current } = inputRef;
    current.focus();

    if (inputValue.length === 0) {
      setSuggestions([]);
      setNoResults(false);
    }
    if (inputValue.length > 2 && !inputValue.startsWith('http')) {
      getSuggestions(false);
    }
  }, [inputValue]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div tw='md:flex items-center gap-4'>
      <Title Type='h3'>Items toevoegen</Title>
      <div tw='relative flex-grow'>
        <Input
          onChange={({ target: { value } }) => setInputValue(value)}
          autoComplete='off'
          value={inputValue}
          ref={inputRef}
          placeholder='Vul hier je zoekterm in'
          iconClick={removeInput}
          IconType={inputValue.length > 0 && TimesIcon}
        />
        <div
          css={[
            tw`absolute w-full z-10`,
            (isLoading || (!isLoading && suggestions.length > 0) || (!isLoading && noResults)) &&
              tw`bg-secondary rounded-lg p-2 md:p-4`,
          ]}
          className='group text-light'
        >
          {isLoading && <LoadingDots />}
          {!isLoading && suggestions.length > 0 && (
            <div tw='h-80'>
              <ScrollBarContent>
                {suggestions.map((item) => (
                  <div tw='flex w-full mb-3 gap-3 md:mb-4 md:gap-4' key={`suggestItem-${item.id}`}>
                    <Item item={item} />
                    <div tw='flex flex-grow flex-shrink-0 justify-end items-center'>
                      {playlistItemIds.indexOf(item.id) >= 0 ? (
                        <Button
                          label='Toegevoegd'
                          ghost
                          noHover
                          hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)}
                          iconProps={{ Type: CheckIcon, color: 'brand' }}
                        />
                      ) : (
                        <Button
                          label='Toevoegen'
                          primary
                          hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)}
                          iconProps={{ Type: ListAddIcon, color: 'dark' }}
                          onClick={() =>
                            addItemToPlaylist({
                              playlistId: currentPlaylistId,
                              itemId: item.id.split('_')[0],
                            })
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </ScrollBarContent>
            </div>
          )}
          {!isLoading && noResults && (
            <div>
              <Title Type='h3'>Geen resultaten gevonden</Title>
              <Paragraph>
                Deze zoekopdracht heeft geen resultaten opgeleverd. Probeer een andere zoekterm.
              </Paragraph>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
